import Slider from "react-slick/lib";
import { StyledImageWrapper } from "../StepSlider/ui";
import React from "react";

const IphoneSlider = ({
  asNavFor,
  refSlider,
  settings,
  sliderContent,
  imageTitle
}) => {
  return (
    <StyledImageWrapper margin={["0", null, null, "0 auto"]} width="100%">
      <div className="img-wrapper">
        <div className="phone-content">
          <div className="phone-header"></div>
          <Slider asNavFor={asNavFor} ref={refSlider} {...settings}>
            {sliderContent.map((el, index) => {
              return (
                <img src={`./images/${el[imageTitle]}`} alt="" key={index} />
              );
            })}
          </Slider>
        </div>
      </div>
    </StyledImageWrapper>
  );
};

export default IphoneSlider;
